import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { environment } from "../../../../../../environments/environment";

@Component({
    selector: "loren-location-filter",
    templateUrl: "./loren-location-filter.component.html",
    styleUrls: ["./loren-location-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenLocationFilterComponent {
  @Input() buttonBottomOffset: number;
  @Input() disabled: boolean;
  @Input() lastSelectedDistance: number;
  @Input() isHandset: boolean;
  @Output() distanceSelected = new EventEmitter<number>();
  @Output() exportTraceStopsDistanceReport = new EventEmitter<void>();

  tenant = environment.tenant;
  showLocationFilterDialog: boolean;
}
